import type { MorphemeGlyphTileSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";

export function getMorphemeGlyphTileSliceMorpheme(
  morphemeGlyphTileSlice: MorphemeGlyphTileSlice,
): string {
  if (morphemeGlyphTileSlice.morphemeType === "grapheme") {
    return morphemeGlyphTileSlice.grapheme;
  }
  return morphemeGlyphTileSlice.characters.map((character) => character.grapheme).join("");
}
